<template>
    <div>
        <BrandForm
            name="marketplace"
            :item=marketplace
            type="marketplace"
            :products="products"
            @create="createMarketplace"
            @update="updateMarketplace"
        />
        <BrandList
            :items=marketplaces
            type="marketplace"
            @edit-item=selectedItem
        />
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
    import BrandForm from "@/components/BrandForm";
    import BrandList from "@/components/BrandList";

    export default {
        name: "AdminMarketplace",
        components: {
            BrandList,
            BrandForm
        },
        created() {
            this.getMarketplaces()
        },
        data() {
            return {
                marketplace: {
                    _id: null,
                    name: "",
                    website: "",
                    logo: ""
                },
                products: [],
            }
        },
        methods: {
            ...mapActions('brand', ['createMarketplace', 'updateMarketplace', 'getMarketplaces', 'getMarketplaceProducts']),
            selectedItem(i){
                this.marketplace = i;
                this.getMarketplaceProducts(i).then((data) => {
                    this.products = data.products;
                });
            }
        },
        computed: {
            ...mapGetters('brand', [
                'marketplaces'
            ])
        }
    }
</script>

<style scoped>

</style>
